function Category({ category }) {
    return (
        <div className="flex flex-col items-center gap-1">
            <div className='size-8 rounded-full overflow-hidden'>
                <img className='size-full object-cover' src={category?.imageLink} alt={category.name} />
            </div>

            <p className='w-full line-clamp-1 text-[8px] leading-3 text-text1'>{category.name}</p>
        </div>
    )
}

function CategorySection({ item }) {
    return (
        <div className='w-full flex flex-col gap-2'>
            <h1 className='text-[10px] leading-3 text-text1 px-2'>{item.name}</h1>

            <div className="px-2 grid grid-cols-5 gap-x-1 w-full gap-2">
                {item.categoryLinkList.map(category => {
                    return (
                        <Category 
                            key={category.id} 
                            category={category} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CategorySection;
